import { USERS_API_URL } from "../config/api";
import { apiClient } from "../utils/apiClient";

export const organizerBusinessDetailsService = {

    async getUserByEmail(email: string) {
        try {
            const response = await apiClient(`${USERS_API_URL}/user?email=${encodeURIComponent(email)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('Error during getting user attributes');
            }

            return await response.json();

        } catch (error) {
            console.error('Error in getUserByEmail:', error);
            throw error;
        }
    },

    async updateUser(userData: any, logoFile: File | null) {
        try {
            const formData = new FormData();

            const userPayload = {
                id: userData.id,
                username: userData.email, // Usualmente el email es el username
                email: userData.email,
                firstName: userData.firstName,
                lastName: userData.lastName,
                organizationName: userData.organizationName,
                contactNumber: userData.contactNumber,
                organizationDescription: userData.organizationDescription,
                role: 'user-organizer'
            };

            formData.append('user', new Blob([JSON.stringify(userPayload)], {
                type: 'application/json'
            }));

            if (logoFile) {
                formData.append('logo', logoFile);
            }

            const response = await apiClient(`${USERS_API_URL}/user`, {
                method: 'PUT',
                body: formData,
                credentials: 'include',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error updating user profile: ${errorText}`);
            }

            return await response.json();

        } catch (error) {
            console.error('Error in updateUser:', error);
            throw error;
        }
    }
};